<template>
  <card>
    <h5
      slot="header"
      class="card-title text-danger font-weight-bold"
    >
      {{ $root.courseName }}
    </h5>
    <div>
      <div class="row">
        <div
          v-for="s in sessions"
          :key="s.Id"
          class="col-12"
        >
          <div class="font-weight-bold h6">
            {{ formatSessionDate(s) }}
          </div>
          <div class="text-right font-italic">
            {{ formatSessionStartTime(s) }} at
            <a
              href="#"
              @click="showLocation(s.Location)"
            >
              {{ s.Location.LocationName }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-6">
        Course Director
      </div>
      <div class="col-6">
        <a :href="'mailto:' + advisors.CourseDirectorEmail">{{ advisors.CourseDirector }}</a>
      </div>
    </div>
    <div
      class="row"
      v-if="this.$root.courseScouterType !== 'Participant'"
    >
      <div class="col-6">
        Role(s)
      </div>
      <div class="col-6">
        {{ advisors.RoleNames }}
      </div>
    </div>
    <div
      class="row"
      v-if="this.$root.courseScouterType !== 'Participant'"
    >
      <div class="col-6">
        Participants
      </div>
      <div
        class="col-6"
        title="Paid in Full / Total Registered"
      >
        {{ advisors.ParticipantsPaidInFull }} / {{ advisors.Participants }}
      </div>
    </div>
    <div
      class="row"
      v-if="this.$root.courseStatus !== 'PreCourse' && this.$root.courseScouterType === 'Participant'"
    >
      <div class="col-6">
        Troop Guide
      </div>
      <div class="col-6">
        <a :href="'mailto:' + advisors.TroopGuideEmail">{{ advisors.TroopGuide }}</a>
      </div>
    </div>
    <div
      class="row"
      v-if="this.$root.courseStatus !== 'PreCourse' && this.$root.courseScouterType === 'Participant' && this.advisors.TicketCounselor !== this.advisors.TroopGuide"
    >
      <div class="col-6">
        Ticket Counselor
      </div>
      <div class="col-6">
        <a :href="'mailto:' + advisors.TicketCounselorEmail">{{ advisors.TicketCounselor }}</a>
      </div>
    </div>
    <modal
      :show.sync="showGoogleMap"
      class="modal-primary"
      :show-close="true"
      header-classes="justify-content-center"
      type="notice"
    >
      <H5 slot="header">
        {{ selectedLocation.LocationName }}
      </H5>
      <div class="image mb-2">
        <div v-html="selectedLocation.GoogleMapUrl" />
      </div>
    </modal>
  </card>
</template>

<script>
import sessionApi from '@/services/api/session.js'
import scouterApi from '@/services/api/scouter.js'
import formatter from '@/services/formatter.js'
import Modal from '@/plugins/paper-components/modal.vue'

export default {
  name: 'HomeSharedCourse',
  components: {
    Modal
  },
  props: {
    errormsg: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      sessions: [],
      advisors: {},
      selectedLocation: {},
      showGoogleMap: false
    }
  },
  mounted: function () {
    sessionApi.get(this.$root.courseKey)
      .then(x => {
        this.sessions = x
        if (this.$root.courseScouterType === 'Participant') {
          this.getCourseAdvisors()
        } else {
          this.getCourseStaffInfo()
        }
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    getCourseStaffInfo: function () {
      scouterApi.getCourseStaffInfo(this.$root.scouterKey, this.$root.courseKey)
        .then(x => {
          this.advisors = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    getCourseAdvisors: function () {
      scouterApi.getParticipantAdvisors(this.$root.courseKey, this.$root.scouterKey)
        .then(x => {
          this.advisors = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    formatSessionDate: function (session) {
      let returnValue = ''
      if (session.StartDate !== null) {
        returnValue += formatter.formatAsShortDate(session.StartDate)
      }
      if (session.EndDate !== null) {
        returnValue += ' - ' + formatter.formatAsShortDate(session.EndDate)
      }
      return returnValue
    },
    formatSessionStartTime: function (session) {
      let returnValue = ''
      if (session.StartDate !== null) {
        returnValue += formatter.formatAsTime(session.StartDate)
      }
      return returnValue
    },
    showLocation: function (loc) {
      this.selectedLocation = loc
      this.showGoogleMap = true
    }
  }
}
</script>
